const documentationConfig = {
    INSTANCE_ES: [
        {
            instance: "INSTANCE_ES",
            title: "components.navigation_bar.esignmanuales",
            typeId: undefined

        }
    ],
    INSTANCE_PT: [
        {
            instance: "INSTANCE_PT",
            title: "components.navigation_bar.esignmanualpt",
            typeId: 1
        },
        {
            instance: "INSTANCE_PT",
            title: "components.navigation_bar.esignmanualresidentialpt",
            typeId: 2
        },
        {
            instance: "INSTANCE_PT",
            title: "components.navigation_bar.esignmanualtetrispt",
            typeId: 3
        }
    ],
    GLOBAL_JLLT: [
        {
            instance: undefined,
            title: "JLLT Users Guide",
            url: "https://jll2.sharepoint.com/teams/JLLT-Legal/SitePages/JLLT-IRIS.aspx",
            typeId: 1,
            external: true
        },
    ]
}

export default {
    getDocumentationConfig(instance) {
        return instance.flatMap(itm => documentationConfig[itm]) 
    }
};